var App = App || {};

App.MortgageCalculator = (function ($) {
    "use strict";

    function init() {
        $("#calc").submit(function () {
            return false;
        })

        $("#price").change(function () {
            //console.log($(this).val())

            var intVal = numeral($(this).val());
            intVal = intVal.value();

            var formatted = numeral($(this).val()).format('0,0');
            var down = intVal;
            $(this).val(formatted);

            down *= 0.2;
            down = numeral(down).format('0,0');
            $("#down-pmt").val(down);
            $("#down-pmt-percent").val("20.00%")
            retotal();

        })

        $("#down-pmt").change(function () {
            var downNumeral = numeral($(this).val());
            var priceNumeral = numeral($("#price").val())

            //console.log(downNumeral.value() + " " + priceNumeral.value())

            var downVal = downNumeral.value();
            var downForm = downNumeral.format('0,0');

            var priceVal = priceNumeral.value();
            var priceForm = priceNumeral.format('0,0');

            var newPercent = downVal / priceVal;

            var newPercentForm = newPercent * 100;
            var newPercentNumeral = numeral(newPercentForm);
            newPercentNumeral = newPercentNumeral.format('0.00');

            $(this).val(downForm);
            $("input#down-pmt-percent").val(newPercentNumeral + "%");
            retotal();
        })

        $("#property-tax").change(function () {
            //console.log($(this).val())

            var intVal = numeral($(this).val());
            intVal = intVal.value();

            var formatted = numeral($(this).val()).format('0,0');
            var down = intVal;
            $(this).val(formatted);
            retotal();
        })

        $("#home-insurance").change(function () {
            //console.log($(this).val())

            var intVal = numeral($(this).val());
            intVal = intVal.value();

            var formatted = numeral($(this).val()).format('0,0');
            var down = intVal;
            $(this).val(formatted);
            retotal();
        })

        $("#extra-fees").change(function () {
            //console.log($(this).val())

            var intVal = numeral($(this).val());
            intVal = intVal.value();

            var formatted = numeral($(this).val()).format('0,0');
            var down = intVal;
            $(this).val(formatted);
            retotal();
        })

        $("#rate-term").change(function () {
            $("#rate-rate").val($(this).val() + "%");
            retotal();
        })

        function retotal() {
            if ($("#price").val()) {
                //console.log( $("#price").val() )
                var homePrice = numeral($("#price").val());
            }

            if ($("#down-pmt").val()) {
                //console.log( $("#down-pmt").val() )
                var downPmt = numeral($("#down-pmt").val());
            }

            if (homePrice && downPmt) {
                var totalMortgage = homePrice.value() - downPmt.value();
                //console.log(totalMortgage);
            }

            var loanTerm = $("#rate-term option:selected").attr("loan-term");
            //console.log("term " + loanTerm)
            var loanTermMonths = loanTerm * 12;

            var rate = $("#rate-term").val();
            //console.log(rate);

            var payment = calculate_payment(totalMortgage, rate, loanTerm);
            //console.log(payment);

            if ($("#property-tax").val()) {
                var taxValue = numeral($("#property-tax").val());
                taxValue = taxValue.value();
                payment += taxValue;
            }

            if ($("#home-insurance").val()) {
                var insuranceValue = numeral($("#home-insurance").val());
                insuranceValue = insuranceValue.value();
                payment += insuranceValue;
            }

            if ($("#extra-fees").val()) {
                var feeValue = numeral($("#extra-fees").val());
                feeValue = feeValue.value();
                payment += feeValue;
            }

            payment = numeral(payment);
            payment = payment.format('0,0.00');

            $("#monthly-price").hide();
            $("p#instruction").hide();
            $("#loading").show();

            setTimeout(function () {
                $("#loading").hide();
                $("#monthly-price").show();
                $("#monthly-price-price").html("$" + payment);
                $("button#getpreapproved").show();
                $("a#approvalLink").show();
            }, 800);
        }

        //Calculate monthly payment
        function calculate_payment(principal, rate, term) {
            var p = principal;
            var r = rate * 0.01;
            var t = term;

            var mo_r = r / 12;
            var months = term * 12;

            var a = 1 + mo_r;

            var power = Math.pow(a, months);

            var b = (mo_r * power) / (power - 1);

            var payment = p * b;

            return payment;
        }
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.MortgageCalculator.init();
});